import { render } from "./DocumentCategory.vue?vue&type=template&id=00b8045a&scoped=true"
import script from "./DocumentCategory.vue?vue&type=script&lang=js"
export * from "./DocumentCategory.vue?vue&type=script&lang=js"

import "../assets/scss/document_category.scss?vue&type=style&index=0&id=00b8045a&scoped=true&lang=scss&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b8045a"]])

export default __exports__